import { Slot, router } from 'expo-router';
import { useContext, useEffect, useRef } from 'react';

import { AuthContext, AuthInterface } from '@fhs-legacy/frontend/src/state/auth';

function shouldRedirectToSupport(location: string): boolean {
  return location === 'PYPESTREAM' || location === '/support';
}

export default function AuthLayout() {
  const { isAuthenticated, originLocation } = useContext(AuthContext) as AuthInterface;

  const isAuthenticatedOnMount = useRef(isAuthenticated);
  const originLocationOnMount = useRef(originLocation);

  useEffect(() => {
    if (isAuthenticatedOnMount.current) {
      if (router.canGoBack()) {
        if (shouldRedirectToSupport(originLocationOnMount.current)) {
          router.replace('/support');
        } else {
          router.back();
        }
      } else {
        router.replace('/');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Slot />;
}
